import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ListGlyph = /*#__PURE__*/createElement("g", {
  id: "list",
  transform: "scale(3.2)"
}, /*#__PURE__*/createElement("rect", {
  x: "0.5",
  y: "0.5",
  width: "4.3334",
  height: "4.3334"
}), /*#__PURE__*/createElement("rect", {
  x: "0.5",
  y: "8.50012",
  width: "4.3334",
  height: "4.3334"
}), /*#__PURE__*/createElement("rect", {
  x: "0.5",
  y: "16.5001",
  width: "4.3334",
  height: "4.3334"
}), /*#__PURE__*/createElement("path", {
  d: "M7.99976 0.666748H24"
}), /*#__PURE__*/createElement("path", {
  d: "M7.99976 4.66675H24"
}), /*#__PURE__*/createElement("path", {
  d: "M7.99976 12.6669H24"
}), /*#__PURE__*/createElement("path", {
  d: "M7.99976 8.66687H24"
}), /*#__PURE__*/createElement("path", {
  d: "M7.99976 16.667H24"
}), /*#__PURE__*/createElement("path", {
  d: "M7.99976 20.6669H24"
}));
const List = createSvg({
  name: 'list',
  path: ListGlyph
});

export default List;
export { ListGlyph };
